"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeasurementType;
(function (MeasurementType) {
    MeasurementType[MeasurementType["SqFt"] = 1] = "SqFt";
    MeasurementType[MeasurementType["SqMeters"] = 2] = "SqMeters";
})(MeasurementType || (MeasurementType = {}));
exports.default = MeasurementType;
